import getOr from 'lodash/fp/getOr'
import omitBy from 'lodash/fp/omitBy'
import compose from 'lodash/fp/compose'

export const strOrNull = value => value == null ? '' : value

export const getOrEmpty = path => compose (
  strOrNull,
  getOr('', path)
)

export const omitEmptyEntities = omitBy(v => v == null || v === '')
